<div class="row">
    <div class="col-xl-4">
        <div class="card card-box mb-5 p-3">
            <div class="d-flex align-items-center pb-4 justify-content-between">
                <div>
                    <div class="font-weight-bold">Deliveries</div>
                    <span class="text-black-50 d-block">Total deliveries to date</span>
                </div>
                <div [countUp]="23485" class="display-4 font-weight-bold text-second"></div>
            </div>
            <div>
                <progressbar [animate]="true" [value]="85"
                             class="progress-sm progress-bar-rounded progress-animated-alt"
                             type="second">
                </progressbar>
                <div class="align-box-row progress-bar--label mt-2 text-muted">
                    <div>Target</div>
                    <div class="ml-auto">100%</div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box mb-5 p-3">
            <div class="d-flex align-items-center pb-4 justify-content-between">
                <div>
                    <div class="font-weight-bold">Orders</div>
                    <span class="text-black-50 d-block">Total orders to date</span>
                </div>
                <div class="display-4 font-weight-bold text-first">
                    $12,346
                </div>
            </div>
            <div>
                <progressbar [animate]="true" [value]="87"
                             class="progress-sm progress-bar-rounded progress-animated-alt" type="first">
                </progressbar>
                <div class="align-box-row progress-bar--label mt-2 text-muted">
                    <div>Target</div>
                    <div class="ml-auto">100%</div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box mb-5 p-3">
            <div class="d-flex align-items-center pb-4 justify-content-between">
                <div>
                    <div class="font-weight-bold">Customers</div>
                    <span class="text-black-50 d-block">Total customers to date</span>
                </div>
                <div class="display-4 font-weight-bold text-warning">
                    $ 2,3M
                </div>
            </div>
            <div>
                <progressbar [animate]="true" [value]="55"
                             class="progress-sm progress-bar-rounded progress-animated-alt" type="warning">
                </progressbar>
                <div class="align-box-row progress-bar--label mt-2 text-muted">
                    <div>Target</div>
                    <div class="ml-auto">100%</div>
                </div>
            </div>
        </div>
    </div>
</div>
